import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})

export class PmsLogsService {

  constructor(
    private http: HttpClient
  ) { }

  UserCount(searchValue, skip, limit) {
    return this.http.get(`${environment.pmsUrl}/getuser?searchValue=${searchValue}&limit=${limit}&skip=${skip}`);
  }

  DailyLog(date: any) {
    return this.http.get(`${environment.pmsUrl}/getdailylog?date=${date}`);
  }

  listUserById(id: any) {
    return this.http.get(`${environment.baseUrl}/user/v1/get-user/${id}`);
  }
}
